import React, { useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { withStyles } from '@material-ui/styles';
import { MenuItem, Menu } from '@material-ui/core';
import { SIZES, SPACES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import { Flex, Margin } from './layout-components';
import Icon from './Icon';
import { DEFAULT_GRAPHS } from 'views/root/views/home/views/performance/views/CustomReport/consts';

const PalleteContainer = styled.div`
  display: inline-block;
  border-radius: 4px;
  border: 1px solid
    ${({ borderColor }) =>
      borderColor ? `${getColor(borderColor)}` : `${getColor('black', 0.23)}`};
  padding: ${({ padding }) => padding};
  width: 100%;
  box-sizing: border-box;

  &:hover {
    border-color: ${({ borderHoverColor }) =>
      borderHoverColor
        ? `${getColor(borderHoverColor)}`
        : `${getColor('black', 0.7)}`};
  }
`;

export const ColorBox = styled.div`
  display: inline-block;
  width: ${({ size }) =>
    size ? size : `calc(${SIZES['x-x-x-large']} - 6px);`};
  height: ${({ size }) =>
    size ? size : `calc(${SIZES['x-x-x-large']} - 6px);`};
  background-color: ${({ color }) => color};
  border: 2px solid
    ${({ isSelected }) =>
      isSelected ? `${getColor('chambray')}` : 'transparent'};
  border-radius: 50%;
  margin-right: 0.3rem;
  cursor: pointer;
`;

const MenuItemWithoutHover = withStyles({
  root: {
    'line-height': 1,
    cursor: 'inherit',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
})(MenuItem);

const MenuItemWithoutPadding = withStyles({
  root: {
    'line-height': 1,
    cursor: 'inherit',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    padding: '0'
  }
})(MenuItemWithoutHover);

export const DEFAULT_COLORS = [
  {
    hex: '#3B48B3',
    label: 'Blue Cola'
  },
  {
    hex: '#5467FF',
    label: 'Gargoyle Gas'
  },
  {
    hex: '#8795FF',
    label: 'Lavender'
  },
  {
    hex: '#B36A00',
    label: 'Gamboge'
  },
  {
    hex: '#FF9800',
    label: 'Maximum Red'
  },
  {
    hex: '#FFB74C',
    label: 'Persian Indigo'
  },
  {
    hex: '#0276AB',
    label: 'North Texas Green'
  },
  {
    hex: '#03A9F4',
    label: 'North Texas Green'
  },
  {
    hex: '#4FC3F7',
    label: 'North Texas Green'
  },
  {
    hex: '#B30000',
    label: 'North Texas Green'
  },
  {
    hex: '#F61C3B',
    label: 'North Texas Green'
  },
  {
    hex: '#F96076',
    label: 'North Texas Green'
  },
  {
    hex: '#008114',
    label: 'North Texas Green'
  },
  {
    hex: '#00B81D',
    label: 'North Texas Green'
  },
  {
    hex: '#4CCD61',
    label: 'North Texas Green'
  },
  {
    hex: '#6A6538',
    label: 'Yellow Metal'
  },
  {
    hex: '#979050',
    label: 'Barley Corn'
  },
  {
    hex: '#B6B184',
    label: 'Mongoose'
  },
  {
    hex: '#798B0D',
    label: 'Christi'
  },
  {
    hex: '#ADC613',
    label: 'La Rioja'
  },
  {
    hex: '#C6D75A',
    label: 'Tacha'
  },
  {
    hex: '#669BB2',
    label: 'Hippie Blue'
  },
  {
    hex: '#5BCEFF',
    label: 'Malibu'
  },
  {
    hex: '#8CDDFF',
    label: 'Anakiwa'
  },
  {
    hex: '#786AB2',
    label: 'Deluge'
  },
  {
    hex: '#AC98FF',
    label: 'Melrose'
  },
  {
    hex: '#C5B7FF',
    label: 'Melrose'
  },
  {
    hex: '#8B11A9',
    label: 'Seance'
  },
  {
    hex: '#C618F1',
    label: 'Electric Violet'
  },
  {
    hex: '#D75DF5',
    label: 'Heliotrope'
  },
  {
    hex: '#A9687F',
    label: 'Turkish Rose'
  },
  {
    hex: '#F294B6',
    label: 'Mauvelous'
  },
  {
    hex: '#F6B4CC',
    label: 'Illusion'
  },
  {
    hex: '#B25132',
    label: 'Medium Carmine'
  },
  {
    hex: '#FF7448',
    label: 'Coral'
  },
  {
    hex: '#FF9E7F',
    label: 'Vivid Tangerine'
  }
];

const ColorPickerPallete = ({
  selectedGraph,
  colors = DEFAULT_COLORS,
  borderColor,
  borderHoverColor,
  boxSize,
  title,
  chunks = 3,
  selectedColor: _selectedColor,
  selectedColorPadding = SPACES.small,
  container,
  openOnTop = false,
  icon,
  onChange = () => {},
  closeOnMouseLeave = false
}) => {
  const [selectedColor, setSelectedColor] = useState(_selectedColor);
  const [anchorEl, setAnchorEl] = useState(null);

  if (selectedGraph && !DEFAULT_GRAPHS.includes(selectedGraph)) return false;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectColor = color => {
    setSelectedColor(color);
    onChange(color);
    handleClose();
  };

  return (
    <>
      {container ? (
        container(
          icon ?? <ColorBox size={boxSize} color={selectedColor} />,
          handleClick
        )
      ) : (
        <PalleteContainer
          aria-controls='simple-menu'
          aria-haspopup='true'
          padding={selectedColorPadding}
          borderColor={borderColor}
          borderHoverColor={borderHoverColor}
          onClick={handleClick}
        >
          <Flex
            direction='row'
            items='center'
            justify='space-between'
            height='100%'
          >
            <ColorBox color={selectedColor} />
            <Icon name='ChevronLeft' direction='right' on='true' />
          </Flex>
        </PalleteContainer>
      )}

      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        autoFocus={!openOnTop}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        {...(openOnTop
          ? {
              getContentAnchorEl: null,
              anchorOrigin: { vertical: 'top', horizontal: 'center' },
              transformOrigin: { vertical: 'bottom', horizontal: 'center' }
            }
          : {})}
      >
        {title && (
          <MenuItemWithoutHover disableRipple>
            <Text color='shuttleGray' size='large'>
              {title}
            </Text>
          </MenuItemWithoutHover>
        )}
        <MenuItemWithoutHover
          disableRipple
          {...(closeOnMouseLeave ? { onMouseLeave: handleClose } : {})}
        >
          {_.chunk(colors, chunks).map((colorChunk, _idx) => (
            <Flex direction='column' key={_idx}>
              {colorChunk.map(({ hex, label }, idx) => (
                <Margin margin='tiny' key={idx}>
                  <ColorBox
                    data-testid={`color-box-${idx}-${_idx}`}
                    isSelected={hex === selectedColor}
                    color={hex}
                    onClick={() => selectColor(hex)}
                  />
                </Margin>
              ))}
            </Flex>
          ))}
        </MenuItemWithoutHover>
      </Menu>
    </>
  );
};

export const ColorPickerPalleteWithoutMenu = ({
  colors = DEFAULT_COLORS,
  chunks = 3,
  selectedColor,
  onChange = () => {}
}) => {
  return (
    <MenuItemWithoutPadding disableRipple>
      {_.chunk(colors, chunks).map((colorChunk, _idx) => (
        <Flex direction='column' key={_idx}>
          {colorChunk.map(({ hex, label }, idx) => (
            <Margin margin='tiny' key={idx}>
              <ColorBox
                data-testid={`color-box-${idx}-${_idx}`}
                isSelected={hex === selectedColor}
                color={hex}
                onClick={() => onChange(hex)}
              />
            </Margin>
          ))}
        </Flex>
      ))}
    </MenuItemWithoutPadding>
  );
};

export default ColorPickerPallete;
